<template>
    <div>
        <Head title="Тарифи"/>
        <h1 class="mb-8 text-3xl font-bold">Тарифи</h1>
        <div class="flex items-center justify-between mb-6">
            <Link
                class="btn-indigo"
                :href="$route('categories.create')"
            >
                <span>Створити</span>
                <span class="hidden md:inline"> тариф</span>
            </Link>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6">Назва</th>
                    <th class="pb-4 pt-6 px-6">Опис</th>
                    <th class="pb-4 pt-6 px-6">Коефіцієнт</th>
                    <th class="pb-4 pt-6 px-6">Озеро</th>
                </tr>
                <tr v-for="category in categories.data" :key="category.id"
                    class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('categories.edit', category.id)"
                            tabindex="-1"
                        >
                            {{ category.name }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('categories.edit', category.id)"
                            tabindex="-1"
                        >
                            {{ category.description }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('categories.edit', category.id)"
                            tabindex="-1"
                        >
                            {{ category.price }}
                        </Link>
                    </td>
                    <td class="border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('categories.edit', category.id)"
                            tabindex="-1"
                        >
                            {{ category.lake_name }}
                        </Link>
                    </td>
                    <td class="w-px border-t">
                        <Link
                            class="flex items-center px-6 py-4 focus:text-indigo-500"
                            :href="$route('categories.edit', category.id)"
                            tabindex="-1"
                        >
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
                        </Link>
                    </td>
                </tr>
                <tr v-if="categories.data.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">Немає жодного запису</td>
                </tr>
            </table>
        </div>
        <pagination class="mt-6" :links="categories.links"/>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon.vue'
import Layout from '@/Shared/Layout.vue'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination.vue'
import SearchFilter from '@/Shared/SearchFilter.vue'

export default {
    components: {
        Head,
        Icon,
        Link,
        Pagination,
        SearchFilter,
    },
    layout: Layout,
    props: {
        categories: Object,
    },
    data() {
        return {
        }
    },
    methods: {
        reset() {
            this.form = mapValues(this.form, () => null)
        },
    },
}
</script>
